/** @file BulkResultDialog: "12 filled, 2 skipped:" and the skipped files with their reasons. */
import type { ReactElement } from 'react';
import { ArtModal } from './ArtModal';
import { bulkHeadline } from './bulkHeadline';
import type { BulkOutcome } from './artTypes';

/** The outcome and the close callback. */
export type BulkResultDialogProps = { outcome: BulkOutcome; onClose: () => void };

/** A dialog with the headline and one row per skipped file. */
export function BulkResultDialog({ outcome, onClose }: BulkResultDialogProps): ReactElement {
  return (
    <ArtModal label="Bulk upload result">
      <strong data-testid="bulk-headline">{bulkHeadline(outcome)}</strong>
      {outcome.skipped.length === 0 ? null : (
        <ul style={{ margin: 0, paddingLeft: 18, overflow: 'auto' }}>
          {outcome.skipped.map((s) => <li key={`${s.name}|${s.reason}`}><code>{s.name}</code>: {s.reason}</li>)}
        </ul>
      )}
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <button type="button" autoFocus style={{ padding: '3px 10px', fontSize: 12 }} onClick={onClose}>Close</button>
      </div>
    </ArtModal>
  );
}
